import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["link"];

  connect() {
    this.update();
  }

  highlight(event) {
    if (
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    ) return;

    this.setActive(event.currentTarget);
  }

  update() {
    this.setActive(this.bestMatch(window.location.pathname));
  }

  setActive(activeLink) {
    this.linkTargets.forEach((link) => {
      if (link === activeLink) {
        link.setAttribute("aria-current", "page");
      } else {
        link.removeAttribute("aria-current");
      }
    });
  }

  bestMatch(path) {
    let best = null;
    let longest = 0;

    this.linkTargets.forEach((link) => {
      const linkPath = new URL(link.href, window.location.origin).pathname;

      if (linkPath === "/") {
        if (path === "/") best = best || link;
        return;
      }

      if (path === linkPath || path.startsWith(`${linkPath}/`)) {
        if (linkPath.length > longest) {
          longest = linkPath.length;
          best = link;
        }
      }
    });

    return best;
  }
}
